export const PENDING_INTENT_STORAGE_KEY = 'jobmatchpro:pending-intent:v1';

const LOCAL_KEY_RULES = [
  { prefix: 'jobmatchpro:active-master-cv-submission:', scoped: true },
  { prefix: 'jobmatchpro:master-cv-draft:', scoped: true },
  { prefix: 'jobmatchpro:master-cv-saved:', scoped: true },
  { prefix: 'jobmatchpro:find-jobs-draft:', scoped: true },
  { exact: 'jobmatch.cv-review' },
  { exact: PENDING_INTENT_STORAGE_KEY },
];

const SESSION_KEY_RULES = [
  { exact: PENDING_INTENT_STORAGE_KEY },
  { exact: 'jobmatchpro:selected-stored-job-id' },
];

function keyMatchesRule(key, rule, userId) {
  if (!key) return false;
  if (rule.exact) return key === rule.exact;
  if (!rule.prefix || !key.startsWith(rule.prefix)) return false;
  if (!rule.scoped) return true;
  const suffix = key.slice(rule.prefix.length);
  if (!suffix) return true;
  return Boolean(userId && suffix === userId);
}

function safeRemoveMatching(storage, rules, userId) {
  if (!storage) return [];
  const removed = [];
  try {
    const keys = [];
    for (let index = 0; index < storage.length; index += 1) {
      const key = storage.key(index);
      if (key) keys.push(key);
    }
    keys.forEach((key) => {
      if (rules.some((rule) => keyMatchesRule(key, rule, userId))) {
        storage.removeItem(key);
        removed.push(key);
      }
    });
  } catch (_) {
    return removed;
  }
  return removed;
}

function getStorage(name) {
  if (typeof window === 'undefined') return null;
  try { return window[name]; } catch (_) { return null; }
}

export function clearJobMatchProBrowserData({ userId, includeSession = true } = {}) {
  if (typeof window === 'undefined') return { localRemoved: [], sessionRemoved: [] };
  const localRemoved = safeRemoveMatching(getStorage('localStorage'), LOCAL_KEY_RULES, userId);
  const sessionRemoved = includeSession
    ? safeRemoveMatching(getStorage('sessionStorage'), SESSION_KEY_RULES, userId)
    : [];
  return { localRemoved, sessionRemoved };
}

export function isJobMatchProManagedKey(key, userId) {
  return LOCAL_KEY_RULES.some((rule) => keyMatchesRule(key, rule, userId))
    || SESSION_KEY_RULES.some((rule) => keyMatchesRule(key, rule, userId));
}
